import type { PillKind, ReportsPageId } from './types';

export const REPORTS_NAV: { id: ReportsPageId; label: string }[] = [
  { id: 'booking-barriers', label: 'Booking barriers' },
  { id: 'competitor-intel', label: 'Competitor intel' },
  { id: 'patient-sources', label: 'Patient sources' },
  { id: 'call-intents', label: 'Call intents' },
  { id: 'patient-faqs', label: 'Patient FAQs' },
  { id: 'knowledge-gaps', label: 'Knowledge gaps' },
  { id: 'escalation-causes', label: 'Escalation causes' },
  { id: 'warm-transfer', label: 'Warm transfer performance' },
];

export const TIME_RANGES = [
  { value: '24h' as const, label: 'Last 24 hours' },
  { value: '7d' as const, label: 'Last 7 days' },
  { value: '30d' as const, label: 'Last 30 days' },
  { value: '90d' as const, label: 'Last 90 days' },
];

export const RPT_TOKENS = {
  green: '#0F5C45',
  greenDeep: '#0A4530',
  greenSoft: 'rgba(15, 92, 69, 0.10)',
  greenWash: 'rgba(15, 92, 69, 0.05)',
  brass: '#A8845C',
  brassDeep: '#8B6B47',
  brassSoft: 'rgba(168, 132, 92, 0.10)',
  brassTint: '#F0E9DC',
  negative: '#A8442E',
  warning: '#B5803D',
  ink3: '#75706A',
  ink4: '#A8A39B',
  ink5: '#D9D5CC',
  iriLinear:
    'linear-gradient(120deg, #4D2855 0%, #8E3567 28%, #D8625F 55%, #D49545 80%, #0F5C45 100%)',
  shadowXs: '0 1px 1px rgba(28,24,18,0.04)',
} as const;

export const PILL_KIND: Record<PillKind, { bg: string; color: string }> = {
  positive: { bg: 'rgba(15, 92, 69, 0.10)', color: '#0F5C45' },
  negative: { bg: 'rgba(168, 68, 46, 0.10)', color: '#A8442E' },
  warning: { bg: 'rgba(181, 128, 61, 0.12)', color: '#B5803D' },
  neutral: { bg: '#F2F0EA', color: '#3D3A33' },
  brass: { bg: '#F0E9DC', color: '#8B6B47' },
  indigo: { bg: '#E5E8F2', color: '#3A4078' },
  pink: { bg: '#F5E0E8', color: '#A0395E' },
};

export const CATEGORY_KIND: Record<string, PillKind> = {
  Financing: 'positive',
  Billing: 'warning',
  Logistics: 'indigo',
  Procedures: 'brass',
  'New Patients': 'positive',
  Providers: 'pink',
  Safety: 'negative',
  Intake: 'neutral',
  Insurance: 'warning',
};

export const OUTCOME_KIND: Record<string, PillKind> = {
  scheduled: 'positive',
  rescheduled: 'positive',
  registered: 'positive',
  answered: 'neutral',
  needs_callback: 'warning',
  transferred: 'warning',
  cancelled: 'negative',
  voicemail: 'neutral',
  dropped: 'negative',
};

export const OUTCOME_LABEL: Record<string, string> = {
  scheduled: 'Scheduled',
  rescheduled: 'Rescheduled',
  registered: 'Registered',
  answered: 'Answered',
  needs_callback: 'Needs callback',
  transferred: 'Transferred',
  cancelled: 'Cancelled',
  voicemail: 'Voicemail',
  dropped: 'Dropped',
};

export const STATUS_KIND: Record<string, PillKind> = {
  answered: 'positive',
  unanswered: 'negative',
  pending: 'warning',
  added: 'positive',
};
